import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Router } from '@angular/router';

@Injectable({ providedIn: 'root' })
export class LegacyTendersEmailRedirectGuard  {
  constructor(private readonly router: Router) {}
  canActivate(route: ActivatedRouteSnapshot) {
    // Redirect legacy tenders email alert URLs (irjpro.com/#/app/tenders/id/:id)
    if (route.fragment && route.fragment.startsWith('/app/tenders/id/')) {
      const fragments = route.fragment.split('/');
      this.router.navigate(['/', 'private', 'tenders', 'items', fragments[fragments.length - 1]]);
    }
    return true;
  }
}
